import React from "react";
import styled from "styled-components";
const Text = styled.p `
    color: ${(props) => props.theme.tertiary};
    margin-bottom: 25px;
`;
const ExplanationText = ({ children }) => (React.createElement(Text, null, children));
export default ExplanationText;
